module.exports = __webpack_public_path__ + "static/img/banner4.cd6a4d19.png";